import { updateItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="section-padding bg-background-50">
      <div className="section-container max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            最新动态
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            平台迭代记录与运营更新，每一条都在让吃瓜体验更好
          </p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-0.5 bg-background-300/60"></div>

          <div className="space-y-6">
            {updateItems.map((item, i) => (
              <div key={i} className="relative pl-10 md:pl-14">
                {/* Timeline dot */}
                <div className={`absolute left-2.5 md:left-4.5 top-1 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full border-2 border-background-50 ${
                  i === 0 ? 'bg-primary-500' : 'bg-background-300'
                }`}></div>

                <div className="p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70">
                  <span className="text-xs text-primary-500 font-semibold">{item.date}</span>
                  <h3 className="mt-1 text-sm md:text-base font-semibold text-foreground-900">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}